import Homecontent from "./data/homecontent";
import { Topheader } from "./common/topheader";
import astro from "./images/astrologer-india-gurgaon.jpg";
import { Innerbanner } from "./common/innerbanner";
import {Footer} from './common/footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhoneSquare } from "@fortawesome/free-solid-svg-icons";
function Aboutme(){


    return(
<div>
<Topheader></Topheader>
<Innerbanner></Innerbanner>

<div className="container-fluid">

    <div className="container">
<div className="d-flex flex-column flex-sm-row flex-lg-row flex-md-row">
<div className="bg-light shadow p-3 m-3  w-50">
  <img  src={astro } alt="famous astrologer Gurgaon" className="img-fluid"></img>
  <h4>Astrologer in New palam Vihar-Sector 110 Gurgaon</h4>
Sanjay Bhargav

    </div>
    <div className="bg-light shadow p-3 m-3 flex-fill">
   <p>
   Best Astrologer in Gurgaon, Sanjay Bhargav was born in 1975 in Shamli, Uttar Pradesh, into a Brahmin family deeply rooted in astrological traditions. His early exposure to the world of astrology came from his family, especially his maternal grandfather who was also a well-respected astrologer


   </p>
    <p>Bhargav is not only well-versed in astrology but also holds a Bsc (PCM) from CCS University. Additionally, he holds several certifications2. Sanjay's educational background provides him with a unique scientific perspective that he integrates into his astrological practices.
</p>
<p>
<span className="fw-bolder">Astrological Expertise: </span>Sanjay Bhargav's methods are a blend of traditional Vedic astrology and modern scientific principles. His expertise lies in Predictive Astrology (Phalit Jyotish), where he uses horoscopes to provide predictions on various life aspects such as career, finance, love, health, and marriage2. He utilizes an array of astrological tools like planet degrees and sub divisional charts (D9, D10, D3, etc.). What sets him apart is his attention to detail, ensuring that even the minutest planetary movements are accounted for2.
</p><p>
<span className="fw-bolder">Astrological Services:</span> Sanjay Bhargav offers a comprehensive range of services, including:
</p><p>
<span className="fw-bolder">Horoscope Reading & Analysis:</span> Detailed personalized readings to help individuals understand their life path and potential challenges.
</p><p>
<span className="fw-bolder">Finance Reports:</span> Insightful reports to help manage and grow wealth.
</p><p>
<span className="fw-bolder">Career Guidance:</span> Advising clients on career-related decisions, including job changes and promotions.
</p><p>
<span className="fw-bolder">Marriage & Relationship Counseling:</span> Assistance with matchmaking, relationship issues, and marital harmony2.
</p><p>
<span className="fw-bolder">Achievements & Recognition:</span> Sanjay Bhargav is widely recognized in the astrological community for his methodical and logical approach to astrology. His ability to blend ancient wisdom with modern techniques has earned him a reputation as one of the best astrologers in India1.
</p><p>
<span className="fw-bolder">Personal Philosophy: </span>Sanjay Bhargav believes that astrology is a science deeply connected with mathematical principles and celestial movements2. He is dedicated to demystifying this field and making it accessible and understandable to everyone, helping people navigate their lives with informed choices.
</p><p>
<span className="fw-bolder">Contact Information:</span> For those looking to consult him, Astrologer Sanjay Bhargav can be reached through his website at Bhargav Astro Point.
</p><p>

Hopefully, this detailed profile gives you a good sense of Astrologer Sanjay Bhargav's background, expertise, and services. Anything else you'd like to know?
</p>
    </div>


</div>


    </div>



</div>
<Footer></Footer>









</div>






 );







    
}
export {Aboutme} ;